











import _ from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import ApiBrand from '@/models/api/brand'
import DropdownSelect from '@spa/components/atoms/DropdownSelect.vue'
import { SelectItem } from '@spa/components/atoms/model/SelectItem'

@Component({
  components: {
    DropdownSelect,
  },
})
export default class BrandSelect extends Vue {

  @Prop({ required: true })
  brands: ApiBrand[]

  @Prop({ required: true })
  selected: string

  get selectList(): SelectItem[] {
    return [
      {
        text: 'ブランドを選択してください', // TODO 文言fix
        value: '',
        selected: _.isEmpty(this.selected),
        disabled: this.brands.length !== 0, // FIXME
      },
      ...this.brands.map(brand => ({
        text: brand.name,
        value: brand.englishName,
        selected: brand.englishName === this.selected,
        disabled: false,
      })),
    ]
  }

  @Emit('input')
  onInput(_selected: string) {
    // Do nothing
  }
}
